/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Race_FlagInputs */

const en_funnel_ob_race_flag = /** @type {(inputs: Funnel_Ob_Race_FlagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done in about 40 min. You just saved ~1h 20m on one paper.`)
};

const es_funnel_ob_race_flag = /** @type {(inputs: Funnel_Ob_Race_FlagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminado en unos 40 min. Acabas de ahorrarte ~1 h 20 min en un solo artículo.`)
};

/**
* | output |
* | --- |
* | "Done in about 40 min. You just saved ~1h 20m on one paper." |
*
* @param {Funnel_Ob_Race_FlagInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_race_flag = /** @type {((inputs?: Funnel_Ob_Race_FlagInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Race_FlagInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_race_flag(inputs)
	return en_funnel_ob_race_flag(inputs)
});